/**
 * The web font stylesheet, shared by the runtime registrar (`register-fonts.web.ts`) and the
 * server-rendered `<head>` (`root-html.tsx`).
 *
 * ONE stylesheet declares the whole `Han Composite` family: `assets/fonts/han-composite`'s split
 * step writes it with a `@font-face` per unicode-range chunk of the heavy faces (Regular, Thin,
 * the TC deltas) plus one per single-file Latin weight, every rule carrying a discrete
 * `font-weight` and a `unicode-range`. That is what lets CJK inside semibold text resolve to a
 * Regular chunk instead of falling to a system font: the browser filters faces by unicode-range
 * first and picks the closest weight among the survivors.
 *
 * Linking it from the server-rendered head lets the browser start fetching the faces with the
 * document, so the first paint is already in the right typeface; the runtime registrar re-links
 * it idempotently for client-only renders.
 */
export const WEB_FONT_STYLESHEET_HREF = "/fonts/split.css";
